export default {
  title: 'Oferta superpuesta en el mismo período',
  buttons: {
    save_as_active: 'Establecer como nueva oferta activa',
    save_as_inactive: 'Guardar como inactiva',
    cancel: 'Cancelar',
  },
  description: {
    base: '{{offer}} se superpone con la oferta activa {{overlappingOffer}} el {{weekday}}{{between}}. Solo puede haber una oferta activa en el mismo período.',
    between: ', entre {{start}}-{{end}}',
  },
  how_to_resolve: {
    title: 'Cómo resolver: elige una opción a continuación.',
  },
};
